export default __webpack_public_path__ + "static/subset-UniNeueRegular-0f38ad474d16d83786c820c7bb24b827.woff2";